var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('quill-editor',{ref:"myQuillEditor",attrs:{"content":_vm.editorContent,"options":_vm.options},on:{"change":_vm.onEditorChange}})}
var staticRenderFns = []

export { render, staticRenderFns }